"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPositionByRef = exports.sleep = void 0;
var sleep = function (ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
};
exports.sleep = sleep;
var getPositionByRef = function (ref) {
    var _a, _b;
    var _c = (_b = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) !== null && _b !== void 0 ? _b : { x: 0, y: 0 }, x = _c.x, y = _c.y;
    return { x: x, y: y };
};
exports.getPositionByRef = getPositionByRef;
